import useMappingIndexList from 'api/mappingIndex/useMappingIndexList/useMappingIndexList';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useMappingIndexTableColumns from 'hooks/mappingIndex/useMappingIndexTableColumns';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const MappingIndex = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getMappingIndexList, loading, mappingIndexList, pageRef] =
    useMappingIndexList(guid);

  const tableRef = useRef(null);

  useEffect(() => {
    if (!guid) return;
    getMappingIndexList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    if (!guid) return;
    getMappingIndexList({ page, count: pageSize });
  }, [pageSize]);

  const [columnsData] = useMappingIndexTableColumns(tableRef);

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getMappingIndexList({
      page: pageNumber,
      count: pageSize,
      term: lastSearch,
    });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getMappingIndexList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(mappingIndexList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={mappingIndexList[page]}
          rows={mappingIndexList[page]}
          pageSize={pageSize}
          isLoading={loading}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}
    </>
  );
};

export default MappingIndex;
